<template>
    <div id="PageTable">
        <v-container 
            class="d-flex align-center justify-center" 
            style="height: 80vh; width: 80vw;"
            v-if="rol != 'root' && rol != 'admin' && rol != 'admin-empresa'"
        >
			<v-card class="" style="border-radius:20px" max-width="500">
                <v-card-title class="justify-center card_titulo">
                    <div class="headerModal">
                        <img :src="'/static/icon/peligro.svg'" class="imgModal"/>
                    </div>
                </v-card-title>
                <v-card-text class="titleModal text-center">
                    Esta vista no esta disponible para este rol de usuario.
                </v-card-text>
                <v-card-actions class="d-flex align-center justify-center card_accion">
                    <v-btn
                        class="btnGuardar"
                        @click="redireccionar()"
                    >
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
		</v-container>
        <v-container v-else grid-list-xl fluid>
            <v-row class="ma-0">
                <v-col lg="12">
                  <data-table
                  ref="tableConfig"
                  :url = url
                  :tableName="'Configuración de notificaciones de contratos'"
                  :columns="columns"
                  :showAdvancedFilters="rol == 'root' ? true : false"
                  :filters="filters"
                  @setFilters="setFilters"
                  @loadModalData="loadModalData"
                  >
                    <template slot="actionButtonsLeft">
                        <div class="botonAgregar" style="padding-right: 12px;">
                            <v-btn
                            rounded
                            color="#004BAF"
                            class="btnAdd"
                            right
                            @click="abrirModal('add')"
                            >
                                <v-icon drak class="mr-2">add</v-icon>Agregar
                                <div class="mr-4"></div>
                            </v-btn>
                        </div>
                    </template>
                    <template slot="filters">
                        <v-row>
                            <v-col cols="12" xs="12" md="12" lg="12" xl="12" class="py-0">
                                <v-autocomplete
                                    :items="clientes"
                                    item-text="nombre"
                                    item-value="id"
                                    label="Cliente"
                                    outlined
                                    v-model="cliente_value"></v-autocomplete>
                            </v-col>
                        </v-row>
                    </template>
                    <tbody slot="body" slot-scope="{data}">
                        <tr v-for="item in data" :key="item.id">
                            <td v-if="rol == 'root'">
                                <div class="tblPrincipal">{{ item.nombre_cliente }}</div>
                            </td>
                            <td>
                                <div class="tblPrincipal">{{ item.dias_anticipacion }}</div>
                            </td>
                            <td>
                                <div class="tblPrincipal">{{ item.aplicar_envio == true ? 'SI' :'NO' }}</div>
                            </td>
                            <td>
                                <div class="tblOpciones">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{on}">
                                            <v-btn 
                                                v-on="on"
                                                slot="activator"
                                                class="botonHover"
                                                icon
                                                fab
                                                dark
                                                small
                                                @click="abrirModal('update',item)">
                                                <v-icon class="tamIconoBoton invertirColorBotones">edit</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Editar</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{on}">
                                            <v-btn 
                                                v-on="on"
                                                slot="activator"
                                                class="botonHover"
                                                icon
                                                fab
                                                dark
                                                small
                                                @click="eliminarConfiguracion(item.id)">
                                                <v-icon class="tamIconoBoton invertirColorBotones">delete</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Eliminar</span>
                                    </v-tooltip>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                 </data-table>
                </v-col>
            </v-row>
        </v-container>
        <!--MODAL-->
        <template>
            <v-dialog v-model="modal" persistent max-width="700px" scrollable>
                <template v-slot:activator="{on}">
                    <v-btn v-on="on" class="botonModal" id="btnModal"></v-btn>
                </template>
                <v-card elevation="0">
                    <ValidationObserver ref="form" v-slot="{invalid}">
                        <v-card-title class="card_titulo justify-center">
                            <div class="headerModal">
                                <img :src="imgModal" class="imgModal" />
                                <h2 class="titleModal">{{ titulo_modal }}</h2>
                            </div>
                        </v-card-title>
                        <v-card-text class="card_texto">
                            <div id="loadingModal" v-show="!finaliza_carga">
                                <div id="loading">
                                    <v-progress-circular 
                                        indeterminate
                                        :size="100"
                                        :width="7"
                                        color="blue"></v-progress-circular>
                                </div>
                            </div>
                            <v-container v-show="finaliza_carga" grid-list-md id="contenedor">
                                <v-divider class="divider"></v-divider>
                                <v-row>
                                    <v-col v-if="rol == 'root'" cols="12" xs="12" md="12" lg="12" xl="12" class="py-0">
                                        <ValidationProvider v-slot="{errors}" name="Cliente" rules="required">
                                            <v-autocomplete
                                            outlined
                                            label="Cliente"
                                            :items="clientes"
                                            item-text="nombre"
                                            item-value="id"
                                            v-model="cliente_value"
                                            required
                                            :error-messages="errors"
                                            ></v-autocomplete>
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col cols="12" xs="12" md="12" lg="12" xl="12" class="py-0">
                                        <multiple-autocomplete
                                        outlined
                                        :items="registros_patronales"
                                        :valorDefecto="registros_seleccionados"
                                        :rules="'required'"
                                        item_text="nombre"
                                        @dataMultiple="(data)=>registros_seleccionados = data"
                                        label="Registros patronales"
                                        ref="multRegistro"
                                        /> 
                                    </v-col>
                                    <v-col cols="12" xs="12" md="12" lg="12" xl="12" class="py-0">
                                        <multiple-autocomplete
                                        outlined
                                        :items="lista_usuarios"
                                        :valorDefecto="usuarios_seleccionados"
                                        :rules="'required'"
                                        item_text="nombre"
                                        @dataMultiple="(data)=>usuarios_seleccionados = data"
                                        label="Usuarios"
                                        ref="multRegistro"
                                        /> 
                                    </v-col>
                                    <v-col cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                            <v-text-field
                                                outlined
                                                autofocus
                                                type="Number"
                                                v-mask="'###'"
                                                label="Días de anticipación"
                                                v-model="configuracion.dias_anticipacion"
                                                ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" xs="12" md="6" lg="6" xl="6" class="py-0">
                                        <v-checkbox
                                        v-model="configuracion.aplicar_envio"
                                        label="Aplicar envío"></v-checkbox>
                                    </v-col>
                                    
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions class="d-flex justify-end card_accion">
                                <v-btn  class="btnCerrar elevation-0"  @click="cerrar()" :disabled="loading_guardar">Cancelar</v-btn>
                                <v-btn class="btnGuardar elevation-0" @click="guardar()" :loading="loading_guardar" :disabled="invalid">Guardar</v-btn>
                            </v-card-actions>
                    </ValidationObserver>
                </v-card>
            </v-dialog>
        </template>
    </div>
</template>

<script>
import {ValidationObserver, ValidationProvider} from 'vee-validate';
import Datatable from '@/components/datatable/Datatable.vue';
import MultipleAutocomplete from '@/components/VuetifyMultipleAutocomplete2';
import clientesApi from '@/api/clientes';
import usuariosApi from '../../api/usuarios';
import configNotificacionesApi from '@/api/contratos/notificaciones';
import registroPatronalApi from '@/api/registros_patronales';
import Notify from '@/plugins/notify';

export default {
    components:{
        "data-table" : Datatable,
        "multiple-autocomplete": MultipleAutocomplete,
        ValidationObserver,
        ValidationProvider,
    },
    data(){
        return{
            url: "contratos/configuraciones-notificaciones/find",
            columns:[
                {
                    label:"Cliente",
                    name:"cliente",
                    filterable:false,
                },
                {
                    label:"Días de anticipación",
                    name:"dias_anticipacion",
                    filterable: false,
                },
                {
                    label:"Aplicar envío",
                    name:"aplicar_envio",
                    filterable: false,
                },
                {
                    label:"Opciones",
                    name:"opciones",
                    filterable:false,
                    align:'center'
                },
            ],
            filters:{
                activo      : true,
                paginate    : true,
                order_by    : 'nombre',
                cliente_id  : null,
            },
            titulo_modal: "",
            configuracion:{
                cliente_id: null,
                registros_patronales: [],
                usuarios: [],
                aplicar_envio: false,
                dias_anticipacion: null,
            },
            clientes:[],
            cliente_value: null,
            registros_seleccionados: [],
            registros_patronales: [],
            datosLogin: '',
            rol: '',
            accion: null,
            imgModal: 'static/modal/catalogoSATcreate.svg',
            modal: false,
            finaliza_carga: true,
            loading_guardar: false,
            params: {activo:true, paginate:false, order:'asc'},
            lista_usuarios: [],
            usuarios_seleccionados: []


        }
    },
    watch:{
        cliente_value:function(val){
            if(val != null || val != ''){
                this.getRegistrosPatronales(val);
                this.getListaUsuarios()
            }
        },
    },
    methods: {

        listar(){
            this.datosLogin = this.$session.get('usuario');
            this.rol = this.datosLogin.rol.name; 
            if(this.rol != 'root'){
                this.cliente_value = this.datosLogin.cliente_id;
                this.filters.cliente_id = this.datosLogin.cliente_id;
                this.columns = [
                    {
                        label:"Días de anticipación",
                        name:"dias_anticipacion",
                        filterable: false,
                    },
                    {
                        label:"Aplicar envío",
                        name:"aplicar_envio",
                        filterable: false,
                    },
                    {
                        label:"Opciones",
                        name:"opciones",
                        filterable:false,
                        align:'center'
                    },
                ];
            }
        },
        setFilters(){
            this.filters.cliente_id = this.cliente_value;
            //console.log(this.filters);
            this.$refs.tableConfig.getData();
        },
        loadModalData(){
            this.reset();
            this.getClientes();
        },
        async abrirModal(accion, item = null){
            this.errors.clear();
            //this.reset();
            this.accion = accion;
            this.modal = true;

            if(this.rol == 'root'){
                this.getClientes();
            }

            if(accion == 'add'){
                this.titulo_modal = 'Nueva configuración'
                this.imgModal = 'static/modal/catalogoSATcreate.svg'
            }else{
                this.titulo_modal = 'Actializar configuración';
                this.imgModal = 'static/modal/catalogoSATupdate.svg'
                this.configuracion.id = item.id;
                this.cliente_value = item.cliente_id;
                this.configuracion.dias_anticipacion = item.dias_anticipacion;
                this.configuracion.aplicar_envio = item.aplicar_envio;
                //convierte el string a tipo array
                this.registros_seleccionados = JSON.parse(item.registros_patronales);
                this.usuarios_seleccionados = JSON.parse(item.usuarios)
            }
        },
        cerrar(){
            this.modal = false;
            this.reset();
        },
        getClientes(){
            clientesApi.getClientes(this.params).then(resp =>{
                //console.log(resp.data);
                this.clientes = resp.data;
            }).catch(err =>{
                console.log('ocurrio un error al cargar los clientes',err);
            })  
        },
        getRegistrosPatronales(id){
            let params = {...this.params, cliente_id:id};
            registroPatronalApi.getRegistrosPatronales(params).then(resp =>{
                //console.log(resp.data);
                this.registros_patronales = resp.data;
            }).catch(err =>{
                console.log('Ocurrio un error', err);
            })
        },
        guardar(){
            this.configuracion.cliente_id = this.cliente_value;
            this.configuracion.registros_patronales = this.registros_seleccionados;
            this.configuracion.usuarios = this.usuarios_seleccionados;
            console.log(this.configuracion);
            this.$refs.form.validate().then(success =>{
                if(success){
                    this.loading_guardar = true;
                    if(this.accion == 'add'){
                        configNotificacionesApi.addConfiguracion(this.configuracion).then(resp =>{
                            Notify.Success("Operación exitosa","La configuración se guardo de manera exitosa.")
                            this.$refs.tableConfig.getData()
                            this.cerrar()
                        }).catch(err =>{
                            this.loading_guardar = false
                            if(typeof err.response.data.error === 'string'){
                            Notify.ErrorToast(err.response.data.error)
                            }else{
                                let error = Object.values(err.response.data.error)
                                let leyenda = ``

                                for (var i = 0; i < error.length; i++){
                                    leyenda += `*` + error[i] + `\n`
                                }

                                Notify.ErrorToast(leyenda)
                            }
                        });
                    }else if(this.accion == 'update'){
                        configNotificacionesApi.updateConfiguracion(this.configuracion).then(resp =>{
                            Notify.Success("Operación exitosa","La configuración se actualizó satisfactoriamente");
                            this.$refs.tableConfig.getData();
                            this.cerrar();
                        }).catch(err =>{
                            this.loading_guardar = false
                            if(typeof err.response.data.error === 'string'){
                            Notify.ErrorToast(err.response.data.error)
                            }else{
                                let error = Object.values(err.response.data.error)
                                let leyenda = ``

                                for (var i = 0; i < error.length; i++){
                                    leyenda += `*` + error[i] + `\n`
                                }

                                Notify.ErrorToast(leyenda)
                            }
                        });
                    }
                }
            })

        },
        eliminarConfiguracion(id){
            Notify. Alert(
            "ADVERTENCIA",
            "¿Estás seguro que deseas eliminar la configuración actual?",
            "Eliminar",
            ()=>{
                configNotificacionesApi.deleteConfiguracion(id).then(resp =>{
                    Notify.Success("Operación exitosa","La configuración se eliminó satisfactoriamente")
                    this.$refs.tableConfig.getData()
                }).catch(err =>{
                    if(typeof err.response.data.error === 'string'){
                        Notify.ErrorToast(err.response.data.error)
                    }else{
                        let error = Object.values(err.response.data.error)
                        let leyenda = ``

                        for (var i = 0; i < error.length; i++){
                            leyenda += `*` + error[i] + `\n`
                        }

                        Notify.ErrorToast(leyenda)
                    }
                })
            })
        },
        reset(){
            if(this.rol == 'root'){
                this.cliente_value = null;
            }
            this.registros_seleccionados = [];
            this.usuarios_seleccionados = [];
            this.configuracion = {
                cliente_id: null,
                registros_patronales: [],
                usuarios: [],
                aplicar_envio: false,
                dias_anticipacion: null,
            },
            this.clientes = [],
            this.loading_guardar = false,
            this.finaliza_carga = true,
            this.$nextTick(()=>{
                if(this.$refs.form){
                    this.$refs.form.reset()
                }
            })

        },
        redireccionar(){
            this.$router.push('/dashboard');
        },
        getListaUsuarios(){
            let params = {
                cliente_id: this.cliente_value, 
                usuario_id: this.datosLogin.id
            }

            usuariosApi.getListUsuarios(params).then(resp =>{
                this.lista_usuarios = resp.data
                //console.log(this.lista_usuarios);
            }).catch(err => {
                console.log('Ocurrio un error: ', err);
            })
        }
    },
    created(){
        this.datosLogin = this.$session.get('usuario');
        //console.log(this.datosLogin);
        this.rol = this.datosLogin.rol.name;
        this.listar();
    }
}
</script>